<template>
    <div class="register">
        <el-dialog
            title="找回密码"
            :visible.sync="isShow"
            :before-close="hide"
            :append-to-body="true"
            :modal-append-to-body="true"
            :close-on-click-modal="false"
            center>
            <div align="center" style="width:100%; ">
                <!-- 这里借鉴了 element-ui form 的做法，使用 display:table 即便是没有内容也会占用空间 -->
                <el-form ref="vform" :model="vform" status-icon :rules="rules" :label-width="vform.lableWidth" :disabled="vform.disable">
                    <el-form-item prop="email" label="邮箱地址">
                        <el-input type="email" v-model="vform.email" autocomplete="off" placeholder="请输入你的邮箱地址" clearable />
                    </el-form-item>
                    <el-form-item align="left">
                        <el-button type="danger" @click="submitForm()" :loading="isSubmitting || isCountDown">提交<span v-show="isCountDown">（{{count}}）</span></el-button>
                    </el-form-item>
                </el-form>
                <div class="reg-footer" align="left">
                    <span>已有账户，</span><el-link type="primary" :underline='false' @click="toLogin">点击</el-link><div class="margin-right-8px">登录</div>
                    <span>|</span>
                    <span class="margin-left-8px">还没有账户，</span><el-link type="primary" :underline='false' @click="toRegister">点击</el-link><div class="margin-right-8px">注册</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {isEmailValid} from "../../../validator";
    import {findPassword} from "../../../data/user";
    import {loadingInstance, errorMessage, successMessage, Styles} from "../../../utils";

    export default {
        name: "FindPassword",
        data() {
            return {
                isShow: false,
                isSubmitting: false,
                isCountDown: false,
                count: 60, //倒计时
                vform: {
                    email: null,
                    lableWidth: '80px',
                    disable: false
                },
                rules: {
                    email: [
                        { required: true, validator: isEmailValid.bind(this), trigger: ['blur', 'change'] }, // 通过 bind 将 this 传入
                    ]
                }
            }
        },
        methods: {
            show(){
                this.isShow = true;
                // 注意，因为 Login Panel 本身没有滚动的情况下，不用禁止 body scroll
                Styles.disableBodyScroll();
            },
            hide(){
                this.isShow = false;
                Styles.enableBodyScroll();
            },
            /**
             * 注意，登录的响应消息目前实现得过于完备，主要是想做成一个 Demo 给其他模块模仿使用
             * @param formName
             */
            submitForm() {
                // 提交按钮倒计时
                this.isCountDown = true; // 禁用 send activate code button
                let countdown = null;
                this.count -= 1;
                countdown = setInterval(()=>{
                    this.count -= 1;
                    if(this.count <=0 ){
                        window.clearInterval(countdown);
                        this.isCountDown = false;
                        this.count = 60;
                    }
                }, 1000)
                // 以下是提交逻辑
                this.isSubmitting = true;
                this.$refs.vform.validate(valid => {
                    if (valid) {
                        this.vform.disable = true;
                        let loading = loadingInstance();
                        findPassword(this.vform.email).then((r)=>{
                            successMessage('重置密码邮件已发送至你的邮箱，请查收');
                        }).catch((error)=>{
                            console.error(error);
                            this.error = '网络超时，请稍后重试';
                            errorMessage('网络超时，请稍后重试');
                        }).finally(()=>{
                            this.vform.disable = false;
                            this.isSubmitting = false;
                            loading.close();
                        });
                    } else {
                        console.error('error submit!!');
                        this.vform.disable = false;
                        this.isSubmitting = false;
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.error = null;
            },
            toRegister(){
                this.isShow = false;
                setTimeout(function(){
                    this.$parent.$refs.register.isShow = true;
                }.bind(this), 200);  // 给一个 timeout 的时间，不然转换太快了。
            },
            toLogin(){
                this.isShow = false;
                setTimeout(function(){
                    this.$parent.$refs.login.isShow = true;
                }.bind(this), 200);  // 给一个 timeout 的时间，不然转换太快了。
            },
            // 当任意 form field 执行过验证后的回调事件，在这里清空 global error，这样就不用侵入各个表达字段的验证方法了。
            formFieldValidated(){
                this.error = null;
            },
            // @deprecated, 体验很不好，message 最好做简单的提示用。
            showError(){
                this.$message({
                    showClose: true,
                    message: '错了哦，这是一条错误消息',
                    type: 'error',
                    duration: 0,
                    offset: 150
                });
            }
        }
    }
</script>

<style scoped>

    .global-error{
        height: 22px;
        width: 100%;
        display: table;
        color: #F56C6C
    }

    .register .reg-button{
        cursor: pointer
    }

    .register .reg-button:hover{
        color: #CB0101
    }

    .reg-footer{
        display:inline-flex;
        width: 100%;
        line-height: 22px;
    }

    /* 设置 form field 输入成功的图标样式 */
    /deep/ .el-icon-circle-check:before{
        color: #67C23A;
        content: "\E720";
    }

    /deep/ .el-dialog{
        width: 468px;  /* 主页展示的最大宽度的一半 */
    }

    @media (min-width: 800px) and (max-width: 1100px){
        /deep/ .el-dialog{
            width: 50%;
        }
    }

    @media (min-width: 736px) and (max-width: 799px){
        /deep/ .el-dialog{
            width: 60%;
        }
    }

    /* 收集展示尺寸 */
    @media (max-width: 735px){
        /deep/ .el-dialog{
            width: 80%;
        }
    }

    @media (min-width: 320px) and (max-width: 540px){
        /deep/ .el-dialog{
            width: 100%;
        }
    }

    /* 调整 el-dialog 的样式 */
    /*/deep/ .el-dialog--center .el-dialog__body{*/
    /*    padding: 2px 10px 10px*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/components/user/login/FindPassword.vue